import React, { useEffect, useState } from "react";
import TextAreaAHSF from "../../Components/TextAreaAHSF";
import ButtonAHSF from "../../Components/ButtonAHSF";
import { useDispatch, useSelector } from "react-redux";
import {
  AddPR_LessonsLearned,
  GetOnePR_LessonsLearnedById,
  UpdatePR_LessonsLearned,
} from "../../Redux/Reducers/ReportStage/LessonsLearned";
import { setRefreshTable } from "../../Redux/Reducers/VariousVariables";
import Swal from "sweetalert2";
import $ from "jquery";
import LoaderAHSF from "../../Components/LoaderAHSF";
import { useParams } from "react-router-dom";
import { decryptToken } from "../../Services/Account/EncryptionParams";
const AddEditeLessonsLearned = (props) => {
  const dispatch = useDispatch();
  let { stageGuid } = useParams();

  stageGuid = decryptToken(stageGuid);
  const state = useSelector((state) => {
    return {
      loadingLessonsLearned: state.LessonsLearned.loadingLessonsLearned,
      LessonsLearned: state.LessonsLearned.LessonsLearned,
    };
  });
  const [lessonsLearnedData, setlessonsLearnedData] = useState({
    pR_LessonsLearnedId: null,
    lessonsLearnedDescription: null,
    pR_ReportsStagesGuid: stageGuid,
  });
  const [validateMassage, setvalidateMassage] = useState(false);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    // This effect runs whenever `props.pR_LessonsLearnedId` changes.
    // If `props` is not null, dispatch an action to get LessonsLearned data using the provided ID.
    if (props != null) {
      dispatch(GetOnePR_LessonsLearnedById(props.pR_LessonsLearnedId));
    }
  }, [props.pR_LessonsLearnedId]);
  // Dependency array: Runs whenever `props.pR_LessonsLearnedId` changes.
  useEffect(() => {
    // This effect runs when `state.LessonsLearned` changes.
    if (
      !state.loadingLessonsLearned && // Check if the data is not still loading.
      props.BtnClick == "edit" // Proceed only if the button click action is "edit".
    ) {
      setLoading(false);
      // Update the state with the LessonsLearned data from the state.
      setlessonsLearnedData({
        ...state.LessonsLearned,
      });
    }
  }, [state.LessonsLearned]);
  //this method to add new column into table LessonsLearned
  const AddApi = async () => {
    setLoading(true);
    const add = await dispatch(
      AddPR_LessonsLearned({
        lessonsLearnedDescription: lessonsLearnedData.lessonsLearnedDescription,
        pR_ReportsStagesGuid: lessonsLearnedData.pR_ReportsStagesGuid,
      })
    );
    //after add api ends it will show popup info
    if (add.payload) {
      $(".close-btn").trigger("click");
      Swal.fire({
        position: "center",
        icon: "success",
        title: "تم اضافة المعلومات بنجاح",
        showConfirmButton: false,
        timer: 1500,
        // width: "500px",
      });
      setLoading(false);
      //then it will refresh table data
      dispatch(setRefreshTable());
    }
  };
  // this method to update on one column by its id
  const UpdateApi = async () => {
    setLoading(true);

    const update = await dispatch(
      UpdatePR_LessonsLearned({
        pR_LessonsLearnedId: props.pR_LessonsLearnedId,
        lessonsLearnedDescription: lessonsLearnedData.lessonsLearnedDescription,
        pR_ReportsStagesGuid: lessonsLearnedData.pR_ReportsStagesGuid,
      })
    );
    //after update ends it will show popup info
    if (update.payload) {
      $(".close-btn").trigger("click");
      Swal.fire({
        position: "center",
        icon: "success",
        title: "تم تعديل المعلومات بنجاح",
        showConfirmButton: false,
        timer: 1500,
        // width: "500px",
      });
      setLoading(false);

      //then it will refresh table data
      dispatch(setRefreshTable());
    }
  };
  //this method to check value befor add or update
  const validatApi = () => {
    //to make validation on data if its not null
    if (
      lessonsLearnedData.lessonsLearnedDescription == null ||
      lessonsLearnedData.lessonsLearnedDescription == ""
    ) {
      //to show border on feild
      setvalidateMassage(true);
    } else {
      //to do action after validate ends
      props.BtnClick == "edit" ? UpdateApi() : AddApi();
    }
  };

  //to render html after loading ends
  return !state.loadingLessonsLearned ? (
    <>
      <div className="">
        {/* Text Area Component */}
        <TextAreaAHSF
          fieldsName="comments"
          show={true}
          disabled={props.shouldDisableFields}
          defaultValue={state.LessonsLearned?.lessonsLearnedDescription}
          onChange={(e) => {
            setlessonsLearnedData({
              ...lessonsLearnedData,
              lessonsLearnedDescription: e.target.value,
            });
          }}
          showValidationMessage={validateMassage}
          validationMessage="يرجى تعبئة هذا الحقل"
        />
        {!props.shouldDisableFields ? (
          <div className="containersButton">
            <div>
              <ButtonAHSF
                type={"submitter"}
                onClick={() => {
                  validatApi();
                }}
                disabled={false}
                title={Object.keys(props).length == 0 ? "إضافة" : "تعديل"}
                text={Object.keys(props).length == 0 ? "إضافة" : "تعديل"}
                show={true}
              />
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
      <LoaderAHSF show={loading} />
    </>
  ) : (
    ""
  );
};

export default AddEditeLessonsLearned;
